import laRomagnaUrl from '../../assets/audio/en/La_Romagna.mp3';
import leDonneUrl from '../../assets/audio/en/Le_donne.mp3';
import mirtetoUrl from '../../assets/audio/en/Mirteto.mp3';
import parcoPartigianoUrl from '../../assets/audio/en/Parco_Partigiano.mp3';

const en = {
  audio0: {
    url: laRomagnaUrl,
    label: 'La Romagna'
  },
  audio1: {
    url: leDonneUrl,
    label: 'Le Donne'
  },
  audio2: {
    url: mirtetoUrl,
    label: 'Mirteto'
  },
  audio3: {
    url: parcoPartigianoUrl,
    label: 'Parco Partigiano'
  },
};

export default en;